<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import CityAutocomplete from '@/components/search/forms/CityAutocomplete.vue'

    // TODO: need to remove dependency on CityAutocomplete
    @Component({mixins: [CityAutocomplete]})
    export class PersonsSearchAutocomplete extends Vue {
        @Prop() companyId

        async searchPersons() {
            const rq = {
                ...(this.companyId && {companyId: this.companyId}),
            }
            const {users} = await this.$api.persons.get(rq)

            // TODO [P1] Need check
            return users?.filter(item => this.itemLabel(item).toLowerCase().includes(this.search?.toLowerCase()))
        }

        async initSearch(val) {
            if (this.loading || !val) return
            this.loading = true
            try {
                this.entries = await this.searchPersons()
            } finally {
                this.loading = false
            }
        }

        itemLabel(entry) {
            return `${entry.firstName ? entry.firstName : ''} ${entry.lastName ? entry.lastName : ''}`
        }

        get locationIcon() {
            return ''
        }
    }

    export default {...toNative(PersonsSearchAutocomplete), ssrRender: CityAutocomplete.ssrRender}
</script>
